/* =====================================================================
 * Kiss-Swipe-Poster Editor (PROJ-50)
 * =====================================================================
 * Reines Text-Poster (imageless-Typo-Familie). Kopiervorlage = familie.js (PROJ-49)
 * (Skelett/Produkt-Tab/Cart) + mrmrs (Wort-Chips) + zuhause (Geocoding).
 *
 * PRINT-MATCH: Die Live-Vorschau spiegelt renderKissSwipe() aus
 * citymap-server/blanket_frontend/print-mode.js 1:1 - Positionen,
 * cqw-Groessen, Strike-SVG-Pfad. Aenderungen IMMER synchron.
 *
 * Layout (Referenz-inspiriert, eigener Aufbau): 3 Statement-Zeilen in Caps,
 * darunter durchgestrichenes Wort (handgezogener SVG-Strich) + Brush-Script-
 * Ersatzwort, unten Namen + DMS-Koordinaten. Default Hochformat.
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.KS_BACKEND_API_URL || 'https://tiles.distantlines.de';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var INK = '#28292d';
  var SANS = "'Outfit', system-ui, sans-serif";
  var SCRIPT = "'adlery-pro', cursive";
  /* Handgezogener Strich durchs Wort (viewBox 0 0 100 12) - 1:1 im Server */
  var STRIKE_PATH = 'M 2 7.5 C 20 5.5, 45 4.5, 62 6 C 78 7.3, 90 6.2, 98 5';

  /* ---- Modul-State (eine Section pro -gestalten-Page) ---- */
  var root, stage, sectionId, autocomplete;
  var state = {
    l1: 'IT ALL', l2: 'STARTED', l3: 'WITH A',
    word_struck: 'KISS',
    word_script: 'swipe',
    names: 'Johanna & Milan',
    coords: 'N 52° 31′ 6.0″   E 13° 19′ 31.0″',
    c_text: '#28292d',
    orientation: 'portrait',
    bg_color: '#ffffff',
    paper_size: '30x40',
    variant_id: '',
    product_type: '',
    frame_color: 'brown'
  };

  /* Dezimal -> DMS (1:1 aus zuhause.js) */
  function toDMS(dec, isLat) {
    var hemi = isLat ? (dec < 0 ? 'S' : 'N') : (dec < 0 ? 'W' : 'E');
    var a = Math.abs(dec);
    var deg = Math.floor(a);
    var minFloat = (a - deg) * 60;
    var min = Math.floor(minFloat);
    var sec = Math.round((minFloat - min) * 60 * 10) / 10;
    if (sec >= 60) { sec = 0; min += 1; }
    if (min >= 60) { min = 0; deg += 1; }
    return hemi + ' ' + deg + '° ' + min + '′ ' + sec.toFixed(1) + '″';
  }
  function coordsFromLatLng(lat, lng) {
    return toDMS(lat, true) + '   ' + toDMS(lng, false);
  }

  function fmFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 60) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  /* ===================================================================
   * Live-Render - 1:1-Spiegel von renderKissSwipe() (Server)
   * =================================================================== */
  function ksText(grid, o) {
    if (o.content == null || String(o.content).trim() === '') return null;
    var el = document.createElement('div');
    el.className = 'text-slot';
    el.textContent = o.content;
    var css = 'position:absolute;z-index:3;left:50%;top:' + o.y + '%;transform:translate(-50%,-50%);' +
      'font-family:' + o.font + ';font-weight:' + (o.weight || 400) + ';' +
      'font-size:' + o.size + 'cqw;color:' + o.color + ';line-height:1;white-space:nowrap;';
    if (o.upper) css += 'text-transform:uppercase;';
    if (o.spacing) css += 'letter-spacing:' + o.spacing + ';';
    el.style.cssText = css;
    grid.appendChild(el);
    return el;
  }

  function render() {
    if (!stage) return;
    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bg_color);
    grid.style.backgroundColor = state.bg_color;
    var col = state.c_text || INK;
    var fits = [];

    // ---- Statement-Zeilen (Caps, luftig gesperrt) ----
    var e1 = ksText(grid, { content: state.l1, y: 21, font: SANS, weight: 500, size: 5.2, color: col, upper: true, spacing: '0.16em' });
    var e2 = ksText(grid, { content: state.l2, y: 27.5, font: SANS, weight: 600, size: 5.2, color: col, upper: true, spacing: '0.16em' });
    var e3 = ksText(grid, { content: state.l3, y: 34, font: SANS, weight: 500, size: 5.2, color: col, upper: true, spacing: '0.16em' });
    fits.push([e1, 74], [e2, 74], [e3, 74]);

    // ---- Durchgestrichenes Wort (handgezogener SVG-Strich) ----
    var struckWord = (state.word_struck || '').trim();
    if (struckWord) {
      var struck = document.createElement('div');
      struck.className = 'text-slot';
      struck.style.cssText = 'position:absolute;z-index:3;left:50%;top:43%;transform:translate(-50%,-50%);' +
        'font-family:' + SANS + ';font-weight:600;font-size:9cqw;color:' + col + ';' +
        'text-transform:uppercase;letter-spacing:0.10em;line-height:1;white-space:nowrap;';
      struck.innerHTML = '<span style="position:relative;display:inline-block;">' + escHtml(struckWord) +
        '<svg viewBox="0 0 100 12" preserveAspectRatio="none" style="position:absolute;left:-5%;top:38%;width:110%;height:0.32em;overflow:visible;">' +
        '<path d="' + STRIKE_PATH + '" stroke="' + col + '" stroke-width="3.4" stroke-linecap="round" fill="none"/></svg></span>';
      grid.appendChild(struck);
      fits.push([struck, 66]);
    }

    // ---- Brush-Script-Ersatzwort ----
    var scriptEl = ksText(grid, { content: state.word_script, y: 54, font: SCRIPT, weight: 400, size: 16, color: col });
    fits.push([scriptEl, 78]);

    // ---- Namen + Koordinaten unten ----
    var namesEl = ksText(grid, { content: state.names, y: 80, font: SANS, weight: 500, size: 2.9, color: col, upper: true, spacing: '0.25em' });
    var coordsEl = ksText(grid, { content: state.coords, y: 84.5, font: SANS, weight: 400, size: 2.0, color: col, spacing: '0.12em' });
    fits.push([namesEl, 76], [coordsEl, 70]);

    stage.innerHTML = '';
    stage.appendChild(grid);
    fits.forEach(function (f) { fmFit(f[0], f[1]); });
  }

  function escHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ===================================================================
   * Wort-Paar-Chips (mrmrs-Muster): Chip setzt beide Felder + State
   * =================================================================== */
  function initChips() {
    var chips = root.querySelectorAll('.ks-chip');
    chips.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        chips.forEach(function (x) { x.classList.remove('current'); });
        c.classList.add('current');
        state.word_struck = c.getAttribute('data-struck') || '';
        state.word_script = c.getAttribute('data-script') || '';
        var si = document.getElementById('ks-struck');
        var sc = document.getElementById('ks-script');
        if (si) si.value = state.word_struck;
        if (sc) sc.value = state.word_script;
        render();
      });
    });
  }

  /* Ort-Suche - Google Places, 1:1 zuhause-Muster (Retry bis API da) */
  function initAutocomplete() {
    if (autocomplete) return;
    var search = document.getElementById('ks-ort-search');
    if (!search) return;
    if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
      setTimeout(initAutocomplete, 250);
      return;
    }
    autocomplete = new google.maps.places.Autocomplete(search, {
      fields: ['geometry'], types: ['geocode']
    });
    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (!place || !place.geometry) return;
      state.coords = coordsFromLatLng(place.geometry.location.lat(), place.geometry.location.lng());
      var coordsInput = document.getElementById('ks-coords');
      if (coordsInput) coordsInput.value = state.coords;
      render();
    });
  }

  /* ===================================================================
   * Eingaben: Hintergrund-Wort, Farben
   * =================================================================== */
  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null) state[key] = el.value;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
  }
  function initColorPickers() {
    root.querySelectorAll('.ks-color[data-key]').forEach(function (p) {
      if (p.value) state[p.dataset.key] = p.value;
      p.addEventListener('input', function () { state[p.dataset.key] = p.value; render(); });
    });
  }
  function initPaperColor() {
    var swatches = root.querySelectorAll('.ks-paper[data-color]');
    function setPaper(hex) {
      state.bg_color = hex;
      swatches.forEach(function (s) {
        s.classList.toggle('current', (s.getAttribute('data-color') || '').toLowerCase() === hex.toLowerCase());
      });
      render();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); setPaper(s.getAttribute('data-color')); });
    });
  }

  /* Info-Gluehbirne (Stadt-/Sternkarten-Muster, .tab-help) */
  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          content.style.display = 'none';
          toggle.classList.remove('is-active');
        });
      }
    });
  }

  /* Tabs (Design / Produkt) - main__switcher-Konvention (editor-tabs.css) */
  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current, fallen damit automatisch.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (nur <=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - Geburtsposter-Schema, orientierungs-treu (zuhause-Muster)
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function effectiveDim() {
    var d = parsePosterDim(state.paper_size);
    var lo = Math.max(d.w, d.h), sh = Math.min(d.w, d.h);
    return state.orientation === 'landscape' ? { w: lo, h: sh } : { w: sh, h: lo };
  }
  function formatPrice(cents) { return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ','); }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = effectiveDim();
    stage.style.setProperty('--collage-aspect', d.w + ' / ' + d.h);
    var flat = stage.closest('.ks-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (d.w / d.h) + ')';
    render();
  }
  function initOrientationPicker() {
    var buttons = root.querySelectorAll('.orientation-picker li a');
    if (!buttons.length) return;
    var current = root.querySelector('.orientation-picker li a.current');
    if (current) state.orientation = current.dataset.orientation || 'landscape';
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        buttons.forEach(function (b) { b.classList.remove('current'); });
        btn.classList.add('current');
        state.orientation = btn.dataset.orientation || 'landscape';
        syncStageToSize();
      });
    });
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('ks-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }
  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add - Muster jahreszahlen.js: Render-Job synchron anstossen,
   * dann /cart/add.js mit _print_image_url + Config-Properties.
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('ks-cart-btn-' + sectionId);
    if (!(state.word_script || '').trim()) { alert('Bitte gib euer Wort ein (z.B. swipe).'); return; }
    if (!(state.names || '').trim()) { alert('Bitte trage eure Namen ein.'); return; }
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var d = effectiveDim();

        var payload = {
          product: 'kiss-swipe',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: d.w, height: d.h, dpi: 300 },
          orientation: state.orientation,
          bg_color: state.bg_color,
          l1: (state.l1 || '').trim(), l2: (state.l2 || '').trim(), l3: (state.l3 || '').trim(),
          word_struck: (state.word_struck || '').trim(),
          word_script: (state.word_script || '').trim(),
          names: (state.names || '').trim(),
          coords: (state.coords || '').trim(),
          c_text: state.c_text || INK
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/kiss-swipe/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/kiss-swipe/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Backend nicht erreichbar -> Fallback-URL bleibt */ }

        /* Alle Properties versteckt (_-Prefix) - Warenkorb zeigt nur Produkt + Preis */
        var props = {
          '_Zeilen': [(state.l1 || '').trim(), (state.l2 || '').trim(), (state.l3 || '').trim()].filter(Boolean).join(' / '),
          '_Wortpaar': [(state.word_struck || '').trim(), (state.word_script || '').trim()].filter(Boolean).join(' → '),
          '_Namen': (state.names || '').trim(),
          '_Koordinaten': (state.coords || '').trim(),
          '_Ausrichtung': state.orientation === 'landscape' ? 'Querformat' : 'Hochformat',
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          '_groesse': state.paper_size,
          '_produkt': 'kiss-swipe'
        };
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[kiss-swipe] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* ===================================================================
   * Init - Input-Values aus dem Markup sind Source of Truth (Playbook §1)
   * =================================================================== */
  function init() {
    root = document.querySelector('.ks-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('ks-stage-' + sectionId);

    bindField('ks-l1', 'l1');
    bindField('ks-l2', 'l2');
    bindField('ks-l3', 'l3');
    bindField('ks-struck', 'word_struck');
    bindField('ks-script', 'word_script');
    bindField('ks-names', 'names');
    bindField('ks-coords', 'coords');
    initChips();
    initColorPickers();
    initPaperColor();
    initOrientationPicker();
    initAutocomplete();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('ks-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
